//#region imports
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProgressBarService } from './progressbar.service';
import { mobileProgressBarModel, ProgressBarModel } from '../shared/model/progressbar.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {
  SignatureComponentModel, SaveAddressModel, Signature4Answers,
  GetLocationRequestModel,
  Signature5Answers,
  SaveCriteriaModel,
  GetFileSaveModel,
  GetFileBytesModel
} from '../module/signature/model/signature.model';
import { GuaranteeService } from './guarantee.service';
import { AppConstants } from 'src/app/app.constants';
import { Globals } from 'src/app/services/globals';
import { Documents } from '../shared/model/document.model';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class SignatureService {
  //#region variables
  acceptanceCriteria = false;
  p5XTxtBoxRequirement = false;
  saveAddress: SaveAddressModel;
  saveCriteria: SaveCriteriaModel;
  signature5Answers: Signature5Answers;
  signature4Answers: Signature4Answers;
  showSignaturePrevious = new Subject<boolean>();
  showSignatureNext = new Subject<boolean>();
  private signatureComponent = new BehaviorSubject<SignatureComponentModel>(null);
  private signatureList = new BehaviorSubject<SaveAddressModel>(null);
  propertyPostalCode: string;
  propertyPostalCodePlace: string;
  propertyAddressBox: string;
  private uploadedPercentage = new BehaviorSubject<number>(0);
  disableSignatureNext = new Subject<boolean>();
 showPrevSignature = false;
  SaveDocuments: Documents;
  premiumFreqencyIndex: any;
  signaturepage3validate = false;
  noIntermediate : string;
  //#endregion

  //#region methods
  constructor(
    private progressBarService: ProgressBarService, private http: HttpClient,
    private globals: Globals, private guranteeService: GuaranteeService) { }

  getData(): any {
    return this.http.get('../../data/SignatureDataJson.json');
  }
  

  setSignatureCurrentPage(
    firstPage: boolean, secondPage: boolean, thirdPage: boolean, fourthPage: boolean, fifthPage: boolean,
    sixthPage: boolean, thanksPage: boolean, refusePage: boolean) {
    const signatureComponent = {
      SignatureQuestion1: firstPage, SignatureQuestion2: secondPage, SignatureQuestion3: thirdPage,
      SignatureQuestion4: fourthPage, SignatureQuestion5: fifthPage, SignatureQuestion6: sixthPage,
      SignatureThanks: thanksPage, SignatureRefuse: refusePage
    };
    this.setSignatureComponent(signatureComponent);
  }

  setPropertyPostalCode(value: string) {
    this.propertyPostalCode = value;
  }

  getPropertyPostalCode(): string {
    return this.propertyPostalCode;
  }

  setnoIntermediate(value: string) {
    this.noIntermediate = value;
  }

  getnoIntermediate(): string {
    return this.noIntermediate;
  }
  setPropertyPostalCodePlace(value: string) {
    this.propertyPostalCodePlace = value;
  }

  getPropertyPostalCodePlace(): string {
    return this.propertyPostalCodePlace;
  }

  setPropertyAddressBox(value: string) {
    this.propertyAddressBox = value;
  }

  getPropertyAddressBox(): string {
    return this.propertyAddressBox;
  }

  checkUserStatus() {
    const signatureData = JSON.parse(sessionStorage.getItem('signatureData'));
    const request = {
      critereRSR: {
        _toDelete: 'false',
        _codePostal: signatureData.Taker_Address_Post_Code,
        _dateNaissance: signatureData.Taker_BirthDate,
        _navigationRSR: {
          _toDelete: 'false',
          _BOF: 'false',
          _EOF: 'false',
          _nombreEnregistrment: '1',
          _typeAction: 'First',
          _cleSecondaire: '01',
          _noFichierRSR: '01'
        },
        _nom: signatureData.Taker_Last_Name,
        _prenom: signatureData.Taker_Name,
        _typeListe: 'NOM'
      }
    };
    return this.http.post<any>(environment.apiURL + 'api/Simulation/GetUserStatus', request);
  }

  setAcceptanceCriteria(value: boolean) {
    this.acceptanceCriteria = value;
  }

  getAcceptanceCriteria(): boolean {
    return this.acceptanceCriteria;
  }

  setSaveAddress1(value: SaveAddressModel) {
    this.saveAddress = value;
  }

  getSaveAddress1(): SaveAddressModel {
    return this.saveAddress;
  }

  setSaveCriteria(value: SaveCriteriaModel) {
    this.saveCriteria = value;
  }

  getSaveCriteria(): SaveCriteriaModel {
    return this.saveCriteria;
  }

  setP5XTxtBoxRequirement(value: boolean) {
    this.p5XTxtBoxRequirement = value;
  }

  getP5XTxtBoxRequirement(): boolean {
    return this.p5XTxtBoxRequirement;
  }

  setSignature4Answers(value: Signature4Answers) {
    this.signature4Answers = value;
  }

  getSignature4Answers(): Signature4Answers {
    return this.signature4Answers;
  }

  setSignature5Answers(value: Signature5Answers) {
    this.signature5Answers = value;
  }

  getSignature5Answers(): Signature5Answers {
    return this.signature5Answers;
  }

  setSignatureComponent(value: SignatureComponentModel) {
    this.signatureComponent.next(value);
  }

  getSignatureComponent(): Observable<SignatureComponentModel> {
    return this.signatureComponent.asObservable();
  }

  setSaveAddress(value: SaveAddressModel) {
    this.signatureList.next(value);
  }

  getSaveAddress(): Observable<SaveAddressModel> {
    return this.signatureList.asObservable();
  }

  setShowSignaturePrevious(value: boolean) {
    this.showSignaturePrevious.next(value);
  }

  getShowSignaturePrevious(): Observable<boolean> {
    return this.showSignaturePrevious.asObservable();
  }

  setShowSignatureNext(value: boolean) {
    this.showSignatureNext.next(value);
  }

  getShowSignatureNext(): Observable<boolean> {
    return this.showSignatureNext.asObservable();
  }

  setDisableSignatureNext(value: boolean) {
    this.disableSignatureNext.next(value);
  }

  getDisableSignatureNext(): Observable<boolean> {
    return this.disableSignatureNext.asObservable();
  }


  setSignatureSaveAddress() {
    const saveAddress: SaveAddressModel = {
      Taker_Civility: null,
      Taker_Name: null,
      Taker_Last_Name: null,
      Taker_BirthDate: null,
      Taker_Address_Post_Code: null,
      Taker_Address_Country: null,
      Taker_Address_Place: null,
      Taker_Address_Street: null,
      Taker_Address_Street_Number: null,
      Taker_Address_Box: null,
      Simulation_mail_Contact: null,
      Simulation_Phone_Contact: null,
      Property_Address_Street: null,
      Property_Address_Street_Number: null,
      Property_Address_Box: null,
      Premium_Frequency_paiement: null,
      Contract_other_company: null,
      Contract_start_date: null,
      Taker_Bank_Account_Number: null,
      Copy_Address: null
    };
    this.setSaveAddress1(saveAddress);
  }

  setPercentage(value: number) {
    this.uploadedPercentage.next(value)
  }

  getPercentage() {
    return this.uploadedPercentage.asObservable();
  }

  setSignatureProgressBarDetails() {
    const characteristicsProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    const detailsProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    const guaranteeProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    const summaryProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    const signatureProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: false
    };
    this.progressBarService.setCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setSignatureProgressStatus(signatureProgressStatus);
  }

  setmobileSignatureProgressBarDetails() {
    const characteristicsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const detailsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const guaranteeProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const summaryProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const signatureProgressStatus: mobileProgressBarModel = {
      Enable: true
    };
    this.progressBarService.setmobileCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setmobileDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setmobileGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setmobileSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setmobileSignatureProgressStatus(signatureProgressStatus);
    if (document.getElementById("tab1") !== null && document.getElementById("tab1") !== undefined 
    && document.getElementById("tab2") !== null && document.getElementById("tab2") !== undefined
    && document.getElementById("tab3") !== null && document.getElementById("tab3") !== undefined
    && document.getElementById("tab4") !== null && document.getElementById("tab4") !== undefined){
    document.getElementById("tab1").classList.remove("d-none");
    document.getElementById("tab2").classList.remove("d-none");
    document.getElementById("tab3").classList.remove("d-none");
    document.getElementById("tab5").classList.remove("d-none");
    document.getElementById("tab4").querySelector(".panel-heading").classList.remove("d-none");
// hidding all scetions once entering the signature section
    document.getElementById("tab1").querySelector(".panel-heading").classList.add("pointer-events-none");
    document.getElementById("tab2").querySelector(".panel-heading").classList.add("pointer-events-none");
    document.getElementById("tab3").querySelector(".panel-heading").classList.add("pointer-events-none");
    document.getElementById("tab4").querySelector(".panel-heading").classList.add("pointer-events-none");
    }
  }

  setThanksProgressBarDetails() {
    const characteristicsProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    const detailsProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    const guaranteeProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    const summaryProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    const signatureProgressStatus: ProgressBarModel = {
      Disable: true, Number: false, Icon: true
    };
    this.progressBarService.setCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setSignatureProgressStatus(signatureProgressStatus);
  }

  setmobileThanksProgressBarDetails() {
    const characteristicsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const detailsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const guaranteeProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const summaryProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const signatureProgressStatus: mobileProgressBarModel = {
      Enable: true
    };
    this.progressBarService.setmobileCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setmobileDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setmobileGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setmobileSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setmobileSignatureProgressStatus(signatureProgressStatus);
    if (document.getElementById("tab1") !== null && document.getElementById("tab1") !== undefined 
    && document.getElementById("tab2") !== null && document.getElementById("tab2") !== undefined
    && document.getElementById("tab3") !== null && document.getElementById("tab3") !== undefined
    && document.getElementById("tab4") !== null && document.getElementById("tab4") !== undefined
    && document.getElementById("tab5") !== null && document.getElementById("tab5") !== undefined ){
    document.getElementById("tab1").classList.remove("d-none");
    document.getElementById("tab2").classList.remove("d-none");
    document.getElementById("tab3").classList.remove("d-none");
    document.getElementById("tab5").classList.remove("d-none");
    document.getElementById("tab4").querySelector(".panel-heading").classList.remove("d-none");
    }
  }

  getCancellationTemplateLocation() {
    return this.http.get<any>(environment.apiURL + AppConstants.APIURLS.GetCancellationTemplateLocation + this.globals.languagecode);
  }

  getOfficesLocation(postcode: any) {
    const lang = this.guranteeService.getLanguage();
    const request: GetLocationRequestModel = {
      GetLocationReq: 'GPS',
      OfficePostalCode: postcode,
      OfficeLanguage: lang === 'FR' ? 'FRA' : 'NLD'
    };
    // return this.http.get<any>(environment.apiURL+ AppConstants.APIURLS.GetOfficeLocation);
    return this.http.post<any>(environment.apiURL + AppConstants.APIURLS.GetOfficeLocation, request);
  }

  getintermediate(postcode: any) {
    const lang = this.guranteeService.getLanguage();
    const request: GetLocationRequestModel = {
      GetLocationReq: 'GetMainOfficeForCPRequest',
      OfficePostalCode: postcode,
      OfficeLanguage: lang === 'FR' ? 'FRA' : 'NLD'
    };
    // return this.http.get<any>(environment.apiURL+ AppConstants.APIURLS.GetOfficeLocation);
    return this.http.post<any>(environment.apiURL + AppConstants.APIURLS.GetIntermediate, request);
  }

  getcodelocalite(postcode: any) {
    const lang = this.guranteeService.getLanguage();
    const request: GetLocationRequestModel = {
      GetLocationReq: 'GetLibelleLocaliteByCodePostal ',
      OfficePostalCode: postcode,
      OfficeLanguage: lang === 'FR' ? 'FRA' : 'NLD'
    };
    // return this.http.get<any>(environment.apiURL+ AppConstants.APIURLS.GetOfficeLocation);
    return this.http.post<any>(environment.apiURL + AppConstants.APIURLS.GetCodeLocalite, request);
  }

  savePdfBytestoFilePath(pdfbytes: string, fnicenumber: string ){
    const request: GetFileSaveModel = {
      PdfBytes: pdfbytes,
      FileName: 'Project_' + fnicenumber + '.pdf'
    };
    return this.http.post<any>(environment.apiURL + AppConstants.APIURLS.SavePDFDocument, request);
  }

  getPdfBytesFromFilePath(fnicenumber: string ){
    const request: GetFileBytesModel = {
      FniceNo: fnicenumber
    };
    return this.http.post<any>(environment.apiURL + AppConstants.APIURLS.GetPDFDocument, request);
  }

  saveSignedDocument() {
    return this.http.post<any>(environment.apiURL + AppConstants.APIURLS.SaveSignedDocument, this.SaveDocuments)
  }
  //#endregion
}
